import { useRef, useState } from "react";
import { Camera, X, Loader2 } from "lucide-react";
import api from "@/api";

export const ParcelPhotosInput = ({ photos, onChange, testid = "parcel-photos" }) => {
  const addRef = useRef(null);
  const replaceRef = useRef(null);
  const replaceIdx = useRef(null);
  const [uploading, setUploading] = useState(false);
  const API = process.env.REACT_APP_BACKEND_URL;

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/parcels/photos", fd);
      if (replaceIdx.current === null) onChange([...photos, data.path]);
      else onChange(photos.map((p, i) => (i === replaceIdx.current ? data.path : p)));
    } catch (e) {}
    replaceIdx.current = null;
    setUploading(false);
  };

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-3">
        {photos.map((p, i) => (
          <div key={p} className="relative" data-testid={`${testid}-item-${i}`}>
            <img
              src={`${API}/api/files/${p}`}
              alt=""
              onClick={() => { replaceIdx.current = i; replaceRef.current?.click(); }}
              className="w-24 h-24 object-cover rounded-xl border border-slate-200 cursor-pointer"
              data-testid={`${testid}-img-${i}`}
            />
            <button
              type="button"
              data-testid={`${testid}-remove-${i}`}
              onClick={() => onChange(photos.filter((_, j) => j !== i))}
              className="absolute -top-2 -right-2 bg-white border border-slate-200 rounded-full p-1 shadow text-slate-500 hover:text-red-500 transition-colors"
              aria-label="Remove"
            >
              <X size={13} />
            </button>
          </div>
        ))}
        {photos.length < 5 && (
          <button
            type="button"
            data-testid={`${testid}-add`}
            disabled={uploading}
            onClick={() => { replaceIdx.current = null; addRef.current?.click(); }}
            className="w-24 h-24 rounded-xl border-2 border-dashed border-slate-300 text-slate-400 hover:border-accent hover:text-accent transition-colors flex flex-col items-center justify-center gap-1"
          >
            {uploading ? <Loader2 size={20} className="animate-spin" /> : <Camera size={20} />}
            <span className="text-[10px] font-semibold">{photos.length}/5</span>
          </button>
        )}
      </div>
      <input ref={addRef} type="file" accept="image/*" className="hidden" data-testid={`${testid}-file-input`} onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} />
      <input ref={replaceRef} type="file" accept="image/*" className="hidden" data-testid={`${testid}-replace-input`} onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} />
    </div>
  );
};
